import React, { useState } from "react";
import LabelsCard from "./LabelsCard";
import { makeStyles } from "@material-ui/core";
import LabelCreationCard from "./LabelCreationCard";
import LabelEditCard from "./LabelEditCard";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../core/redux/ducks/label";

export function Label({
  onClose,
  setLabel,
  articleId,
  snippetLabels,
  removeLabel,
}) {
  const [isCreate, setCreate] = useState(false);
  const [updateLabel, setUpdateLabel] = useState({ status: false, label: {} });
  const dispatch = useDispatch();
  const setNewLabel = (label) => Actions.newLabel(dispatch, articleId, label);
  const { labels } = useSelector((state) => state.label);
  const classes = useStyles();

  const handleAddLabel = (label) => {
    if (setLabel) setLabel(label);
  };

  const handleRemoveLabel = (label) => {
    removeLabel(label);
  };

  const handleEditLabel = (updatedLabel) => {
    Actions.editLabel(dispatch, updatedLabel);
  };

  const handleCloseCreate = (created) => {
    if (!created) onClose();
    else setCreate(false);
  };

  const handleCloseEdit = (created) => {
    if (!created) onClose();
    else setUpdateLabel({ status: false, label: {} });
  };

  const handleDeleteLabel = (labelId) => {
    Actions.deleteLabel(dispatch, labelId);
  };

  if (isCreate || !labels || !labels.length) {
    return (
      <div className={classes.root}>
        <LabelCreationCard
          onClose={handleCloseCreate}
          setLabel={(label) => setNewLabel(label)}
          // onRemoveLabel={handleRemoveLabel}
        />
      </div>
    );
  } else {
    if (updateLabel.status) {
      return (
        <div className={classes.root}>
          <LabelEditCard
            onClose={handleCloseEdit}
            onEditLabel={handleEditLabel}
            label={updateLabel.label}
            onDeleteLabel={handleDeleteLabel}
          />
        </div>
      );
    } else {
      return (
        <div className={classes.root}>
          <LabelsCard
            onClose={onClose}
            setCreate={() => setCreate(true)}
            onEditLabel={setUpdateLabel}
            labels={labels}
            onAddLabel={handleAddLabel}
            onRemoveLabel={handleRemoveLabel}
            snippetLabels={snippetLabels}
          />
        </div>
      );
    }
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "200px",
  },
}));
